var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"DistributorsPage"},[_c('IllustrationBanner'),_c('div',{staticClass:"container"},[_c('h2',{staticClass:"color--primary"},[_vm._v(_vm._s(_vm.$t('distributorsPageHeading')))]),_c('DistributorList',{attrs:{"distributors":_vm.distributors}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }